<template>
    <div class="ui-auth">
        <a class="ui-auth__user"
            v-if="isAuthorized"
            v-bind:href="urls.dashboard"
            >
            <icon name="user" v-bind:original="true" />
        </a>
        <div class="ui-auth__login"
            v-else
            >
            <div class="ui-auth__login-item-mobile">
                <ui-button
                    v-bind:href="urls.login"
                    size="xs"
                    theme="transparent"
                    target="_self"
                    is-width-free
                    >
                    Войти
                </ui-button>
            </div>
            <div class="ui-auth__login-item">
                <ui-button
                    v-bind:href="urls.login"
                    theme="primary"
                    target="_self"
                    >
                    Войти
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'ui-auth-v2',
    data: () => ({
        urls: {
            dashboard: config.urls.cabinet.dashboard,
            login: config.urls.auth.login + '?next=' + window.location.pathname,
        },
    }),
    computed: {
        user() {
            return this.$store.getters['users/user'];
        },
        isAuthorized() {
            return this.$store.getters['users/isAuthorized'];
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.ui-auth {
    &__user {
        display: block;

        font-size: 3.6rem;
        text-decoration: none;

        cursor: pointer;
    }
    &__login {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: -4px;
        &-item-mobile {
            display: none;
        }
        &-item {
            padding: 4px;
        }
    }
    @media @media-md-down {
        &__login {
            &-item-mobile {
                display: block;
            }
            &-item {
                display: none;
            }
        }
    }
}
</style>
